import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function TryoutSuccess() {
    const [params] = useSearchParams();
    const session_id = params.get("session_id");
    const [status, setStatus] = useState("checking");
    const [tries, setTries] = useState(0);

    useEffect(() => {
        if (!session_id) { setStatus("error"); return; }
        let cancelled = false;
        let attempts = 0;
        const poll = async () => {
            attempts++;
            setTries(attempts);
            try {
                const { data } = await api.get(`/payments/status/${session_id}`);
                if (cancelled) return;
                if (data.payment_status === "paid") setStatus("paid");
                else if (data.status === "expired") setStatus("expired");
                else if (attempts >= 8) setStatus("timeout");
                else setTimeout(poll, 2000);
            } catch {
                if (attempts >= 8) setStatus("error"); else setTimeout(poll, 2000);
            }
        };
        poll();
        return () => { cancelled = true; };
    }, [session_id]);

    return (
        <div data-testid="tryout-success-page" className="min-h-[70vh] grid place-items-center px-5 grain">
            <div className="card-flat p-10 max-w-lg text-center">
                {status === "checking" && (
                    <>
                        <Loader2 className="mx-auto text-gold animate-spin" size={40} />
                        <h2 className="h-display text-3xl mt-5">Confirming Payment…</h2>
                        <p className="text-ink mt-3 text-sm">Attempt {tries}/8</p>
                    </>
                )}
                {status === "paid" && (
                    <>
                        <CheckCircle2 className="mx-auto text-green-400" size={48} />
                        <h2 className="h-display text-4xl mt-5">You're In.</h2>
                        <p className="text-white/80 mt-3">Your spot is locked. Tryout details have been sent to your email. See you on the floor.</p>
                        <Link to="/" className="btn-gold inline-block mt-6 px-7 py-4 text-xs" data-testid="ty-home-btn">Back Home</Link>
                    </>
                )}
                {(status === "expired" || status === "timeout" || status === "error") && (
                    <>
                        <XCircle className="mx-auto text-red-400" size={48} />
                        <h2 className="h-display text-3xl mt-5">Payment Not Confirmed</h2>
                        <p className="text-ink mt-3">{status === "expired" ? "Your session expired." : "Couldn't verify payment. Try again or contact support."}</p>
                        <Link to="/tryouts" className="btn-ghost-gold inline-block mt-6 px-7 py-4 text-xs">Retry Tryouts</Link>
                    </>
                )}
            </div>
        </div>
    );
}
